import React from "react";
import theme from "../ui/theme";
import useTranslations from "../Translations/useTranslations";
import { useAuth } from "../Auth/useAuth";
import { Accordion, Card } from "react-bootstrap";

function CriteresList({ criteres, selectedCriteres, selectCritere }) {
  const [{ user }] = useAuth();
  const trl = useTranslations();

  const style = {
    ul: {
      listStyleType: "none",
      margin: 0,
      padding: 0,
      overflowY: "scroll",
      position: "relative",
      minWidth: 340,
    },
    title: {
      padding: theme.spacing(1),
      position: "sticky",
      top: 0,
      color: "white",
      fontWeight: "bold",
      background: theme.primary,
      color: "#171717",
    },
    li: {
      padding: theme.spacing(0.5),
      display: "flex",
      alignItems: "center",
    },
    radio: {
      width: 15,
      height: 15,
      borderRadius: 50,
      background: "#eceff4",
      boxShadow: "inset 1px 1px 3px #c5cbd1, inset -2px -2px 3px #ffffff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    radio_selected: {
      width: 9,
      height: 9,
      borderRadius: 50,
      backgroundColor: theme.primary,
    },
  };

  if (!criteres) return null;
  //
  return (
    <Accordion style={style.ul} defaultActiveKey="0">
      {criteres.critere_1 && (
        <React.Fragment>
          {/* Liste des criteres 1 */}
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0" style={style.title}>
              <li>
                {trl.data.message(
                  "SOCIETES",
                  "CODSOC",
                  user.data.societe,
                  "LABEL_CR1"
                )}
              </li>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                {criteres.critere_1.criteres.map((critere) => (
                  <li
                    style={style.li}
                    key={critere.CODCR1}
                    onClick={() => selectCritere({ critere_1: critere.CODCR1 })}
                  >
                    <div style={style.radio}>
                      {selectedCriteres.critere_1 === critere.CODCR1 && (
                        <div style={style.radio_selected}></div>
                      )}
                    </div>
                    <span className="ml-2">
                      {trl.data.message(
                        "CR1",
                        "CODCR1",
                        critere.CODCR1,
                        "LIBCR1"
                      )}
                    </span>
                  </li>
                ))}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </React.Fragment>
      )}
      {criteres.critere_2 && (
        <React.Fragment>
          {/* Liste des criteres 2 */}
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="1" style={style.title}>
              <li>
                {/* {criteres.critere_2.name} */}
                {trl.data.message(
                  "SOCIETES",
                  "CODSOC",
                  user.data.societe,
                  "LABEL_CR2"
                )}
              </li>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                {" "}
                {criteres.critere_2.criteres.map((critere) => (
                  <li
                    style={style.li}
                    key={critere.CODCR2}
                    onClick={() => selectCritere({ critere_2: critere.CODCR2 })}
                  >
                    <div style={style.radio}>
                      {selectedCriteres.critere_2 === critere.CODCR2 && (
                        <div style={style.radio_selected}></div>
                      )}
                    </div>
                    <span className="ml-2">
                      {trl.data.message(
                        "CR2",
                        "CODCR2",
                        critere.CODCR2,
                        "LIBCR2"
                      )}
                    </span>
                  </li>
                ))}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </React.Fragment>
      )}
      {criteres.critere_3 && (
        <React.Fragment>
          {/* Liste des criteres 3 */}
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="2" style={style.title}>
              <li>
                {trl.data.message(
                  "SOCIETES",
                  "CODSOC",
                  user.data.societe,
                  "LABEL_CR3"
                )}
              </li>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                {criteres.critere_3.criteres.map((critere) => (
                  <li
                    style={style.li}
                    key={critere.CODCR3}
                    onClick={() => selectCritere({ critere_3: critere.CODCR3 })}
                  >
                    <div style={style.radio}>
                      {selectedCriteres.critere_3 === critere.CODCR3 && (
                        <div style={style.radio_selected}></div>
                      )}
                    </div>
                    <span className="ml-2">
                      {trl.data.message(
                        "CR3",
                        "CODCR3",
                        critere.CODCR3,
                        "LIBCR3"
                      )}
                    </span>
                  </li>
                ))}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </React.Fragment>
      )}
      {!criteres.critere_1 && !criteres.critere_2 && !criteres.critere_3 && (
        <div className="py-3 px-3 text-center">
          {trl.message("MainPage.Dialog.noFilters")}
        </div>
      )}
    </Accordion>
  );
}

export default CriteresList;
